import { render, staticRenderFns } from "./customInput.vue?vue&type=template&id=13c4267e&scoped=true&"
import script from "./customInput.vue?vue&type=script&lang=js&"
export * from "./customInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4267e",
  null
  
)

export default component.exports